<div *ngIf="pageData" class="sk-static-page-container">
  <h1 class="mb-4 user-select-none" [innerText]="pageData.attributes.title"></h1>
  <markdown [data]="pageData.attributes['text']"></markdown>
</div>
